import script from "./OffresView.vue?vue&type=script&setup=true&lang=js"
export * from "./OffresView.vue?vue&type=script&setup=true&lang=js"

import "./OffresView.vue?vue&type=style&index=0&id=4194d5ff&lang=css"

const __exports__ = script;

export default __exports__